module.exports = __webpack_public_path__ + "static/media/IMG_4279.8a8ad297.PNG";